export function encodeBase64(string: string) {
  return encodeURIComponent(string.replace(' ', '+'));
}
